
//Material Icons
import 'material-icons/iconfont/material-icons.css';

// Vuesax
import 'vuesax/dist/vuesax.css';

// Styles: SCSS
import '@/assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Feather font icon
require('@/assets/css/iconfont.css');

import { themeConfig } from '@/constants/config';

import Vue from 'vue';

// Vuesax Component Framework
import Vuesax from 'vuesax';

import {colors} from '@/constants/config';
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl });

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer';
Vue.use(VueHammer);
